import * as React from "react"
import { Box, Skeleton, Typography } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"


export default function ProductPagesImagesDetailCatalogueBlock({ selected, isLoadingCatalogue, catalogueData=[] }) {

	if (isLoadingCatalogue)
		return <Skeleton variant="rectangular" height={200} />

	return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', color: 'text.disabled' }}>
		{ !!catalogueData.length && <Typography variant="h6">
			Catalogue
		</Typography> }

		<Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-evenly', overflowX: 'auto', width: '100%', px: 3 }}>
			{catalogueData.map((item, idx) => <Box key={idx} sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 75 }}>
				<ImageSeeker
					src={item.catalogueURL}
					onClick={() => selected.value = item.imageSkuID === selected.value ? null : item.imageSkuID}
					sx={{
						width: 50, height: 50, cursor: "pointer",
						...selected.value === item.imageSkuID && { border: "3px solid", borderColor: "info.main" }
					}}
				/>
				{ !!item.subtitle && <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
					{(item?.subtitle || '').includes("Product 360")
						? item.subtitle.replace(/(\d)$/, '')
						: item.subtitle.replace(/\d+/g, '')}
				</Typography> }
			</Box>)}
		</Box>

	</Box>
}